export default __webpack_public_path__ + "static/media/banner-seguro-multirrisco-desktop.19a3233a.png";